import React, { useEffect } from 'react';
import { classNames } from 'primereact/utils';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { useAuth } from './hooks/auth-provider';
import NetworkStatus from './utilities/NetworkStatus';

import { useScanResult } from './store';
import { ScanedList } from './utilities/scanedList';
import { ScanedArtikal } from './utilities/selectArtikal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFire } from '@fortawesome/free-solid-svg-icons';
import { CanAccess } from './components/permissions';

import i18n from './i18n';

const isProduction = process.env.REACT_APP_IS_PRODUCTION === 'true';
const distributionName = process.env.REACT_APP_DISTRIBUTION_NAME || '';

const AppTopbar = (props) => {
    const navigate = useNavigate();

    const setShowListDialog = useScanResult((state) => state.setShowListDialog);
    const setDialogCallback = useScanResult((state) => state.setDialogCallback);

    const onScanedDialogOpen = (event, item) => {
        setShowListDialog(true);
        setDialogCallback(false);
    };

    const onAlertDialogOpen = (event, item) => {};

    const onTopbarItemClick = (event, item) => {
        if (props.onTopbarItemClick) {
            props.onTopbarItemClick({
                originalEvent: event,
                item: item
            });
        }
    };

    // get curent user
    const { login, isLoggedin, logout, getCurrentUser, getCSRFToken } = useAuth();

    const { scanResult } = useScanResult();

    const onQrIconClick = (event, item) => {
        if (props.onQrIconClick) {
            props.onQrIconClick({
                originalEvent: event,
                item: item
            });
        }
    };

    const onLogout = () => {
        logout().then(
            (res) => {
                // Uspešan logout
                console.log('Logout successful:', res);

                // Očisti sve lokalne podatke
                localStorage.clear();
                sessionStorage.clear();

                // Resetuj axios headers
                if (window.api && window.api.defaults) {
                    delete window.api.defaults.headers.common['Authorization'];
                }

                // Redirektuj na login stranicu
                navigate('/login', { replace: true });

                // Opcionalno - reload stranice za potpuno čišćenje
                // window.location.reload();
            },
            (error) => {
                // Greška tokom logout-a, ali ipak očisti lokalne podatke
                console.error('Logout error:', error);

                // Očisti sve lokalne podatke čak i ako API poziv nije uspešan
                localStorage.clear();
                sessionStorage.clear();

                // Resetuj axios headers
                if (window.api && window.api.defaults) {
                    delete window.api.defaults.headers.common['Authorization'];
                }

                // Redirektuj na login stranicu
                navigate('/login', { replace: true });
            }
        );
    };

    const onProfile = () => {
        navigate('/my-profile');
    };

    const curentUser = getCurrentUser();

    // onScanedDialogOpen    handler

    return (
        <div className="layout-topbar" style={!isProduction ? { backgroundColor: '#f97316' } : {}}>
            <button type="button" className="p-link layout-menu-button layout-topbar-icon" onClick={props.onMenuButtonClick}>
                <i className="pi pi-bars"></i>
            </button>

            <button type="button" className="p-link layout-topbar-logo " onClick={() => navigate('/')}>
                <FontAwesomeIcon icon={faFire} className="text-green-600 text-3xl topbar-icon pi  pi-fw pi-home text-white text-xl mr-2" />
                <span className="text-300 text-2xl">
                    <b className="text-white">G</b>C{!isProduction && <span className="text-white ml-2 text-xs">(TEST)</span>}
                </span>
            </button>

            <ul className="topbar-menu">
                <li className={classNames('user-profile', { 'active-topmenuitem fadeInDown': props.activeTopbarItem === 'profile' })}>
                    {curentUser && (
                        <button type="button" className="p-link" onClick={(e) => onTopbarItemClick(e, 'profile')}>
                            <i className="pi pi-fw pi-user topbar-icon text-3xl text-white "></i>
                            <div className="layout-profile-userinfo">
                                <span className="layout-profile-name">{curentUser.ime}</span>
                                <span className="layout-profile-role">{curentUser.title}</span>
                            </div>
                        </button>
                    )}
                    <ul className="fadeInDown">
                        <li role="menuitem">
                            <button type="button" className="p-link" onClick={onProfile}>
                                <i className="pi pi-fw pi-user mr-2"></i>
                                <span>Moj profil</span>
                            </button>
                        </li>
                        <li role="menuitem">
                            <button type="button" className="p-link" onClick={onLogout}>
                                <i className="pi pi-fw pi-sign-out mr-2"></i>
                                <span>Izloguj me</span>
                            </button>
                        </li>
                    </ul>
                </li>
                <CanAccess rolesExclude={['inzenjer']}>
                    <li className={classNames('user-profile')}>
                        <button type="button" className="p-link layout-topbar-icon" onClick={(e) => onQrIconClick(e, 'settings')}>
                            <i className="topbar-icon pi pi-fw pi-qrcode  text-3xl "></i>
                        </button>
                    </li>{' '}
                </CanAccess>
                <CanAccess rolesExclude={['inzenjer']}>
                    <li className={classNames({ 'active-topmenuitem fadeInDown': props.activeTopbarItem === 'settings' })}>
                        <button type="button" className="p-link layout-topbar-icon" onClick={(e) => onScanedDialogOpen(e, 'settings')}>
                            <i className="topbar-icon pi pi-fw pi-bell p-overlay-badge">{scanResult.length > 0 && <Badge value={scanResult.length} severity="danger"></Badge>}</i>
                        </button>
                    </li>
                </CanAccess>
            </ul>
            <ScanedList />
            <ScanedArtikal />
        </div>
    );
};

export default AppTopbar;
